export default {
  header: 'Huidige stap',
  done: 'Klaar',
  inProgress: 'Bezig',
  notStarted: 'Niet gestart',
};
